module.exports = __webpack_public_path__ + "static/media/karolinas.da79f037.jpg";